import { createUrl } from 'app/utils';
import { Flex, Typography } from 'components';
import { AuthButton } from 'features/auth/components';
import React from 'react';
import { Link } from 'react-router-dom';

const RegisterSuccessView = () => {
  return (
    <>
      <Flex flexDirection="column">
        <Flex flexDirection="column" p={{ m: 30, d: 45 }}>
          <Typography type="type4" color="authLabelColor" fontWeight="bold">
            Cadastro realizado com sucesso.
          </Typography>

          <Typography type="type2" color="authLabelColor" mt={3}>
            Você receberá um e-mail com instruções para criar sua senha e finalizar seu cadastro.
          </Typography>
        </Flex>

        <Link to={createUrl('login')}>
          <Flex>
            <AuthButton className="btn-goto-login" type="button">
              Ir para o login
            </AuthButton>
          </Flex>
        </Link>
      </Flex>
    </>
  );
};

export default RegisterSuccessView;
